import { SAVE_START, SAVE_SUCCESS, SAVE_ERROR, RESET, GAME_SUCCESS  } from "../actions/game";

const gameReducer = (state = {}, action) => {
  switch (action.type) {
    case SAVE_START:
      return (state = {
        ...state,
        isSaving: true
      });
      break;
    case SAVE_SUCCESS:
      return (state = {
        ...state,
        isSaved: true,
        isSaving: false
      });
      break;
    case SAVE_ERROR:
      return (state = {
        ...state,
        isSaved: false,
        isSaving: false
      });
      break;
    case RESET:
      return (state = {
        ...state,
        isSaved: false
      });
    case GAME_SUCCESS:
      return (state = {
        ...state,
        partidas: action.response
      });
    default:
      return state;
  }
};

export default gameReducer;
